import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { HomeIcon, UsersIcon, BarChartIcon, CalendarIcon, MusicIcon, CheckSquareIcon, MessageSquareIcon, TrendingUpIcon } from 'lucide-react';
import { useTheme } from './providers/ThemeProvider';
interface TeacherSidebarProps {
  closeSidebar?: () => void;
}
export const TeacherSidebar: React.FC<TeacherSidebarProps> = ({
  closeSidebar
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  const currentPath = location.pathname;
  const [focusedIndex, setFocusedIndex] = useState<number | null>(null);
  const menuItems = [{
    path: '/teacher-dashboard',
    icon: HomeIcon,
    label: 'Dashboard'
  }, {
    path: '/my-students',
    icon: UsersIcon,
    label: 'Students'
  }, {
    path: '/assigned-tasks',
    icon: CheckSquareIcon,
    label: 'Assigned Tasks'
  }, {
    path: '/reports',
    icon: BarChartIcon,
    label: 'Reports'
  }, {
    path: '/teacher/calendar',
    icon: CalendarIcon,
    label: 'Calendar'
  },
  // TEMPORARILY HIDDEN: Messages feature not ready for teachers
  // {
  //   path: '/teacher-messages',
  //   icon: MessageSquareIcon,
  //   label: 'Messages',
  // },
  {
    path: '/teacher-sheet-music',
    icon: MusicIcon,
    label: 'Sheet Music'
  }, {
    path: '/revenue',
    icon: TrendingUpIcon,
    label: 'Revenue'
  }];
  // Keyboard navigation handler
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (focusedIndex === null) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (focusedIndex < menuItems.length - 1) {
          setFocusedIndex(focusedIndex + 1);
        }
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (focusedIndex > 0) {
          setFocusedIndex(focusedIndex - 1);
        }
      } else if (e.key === 'Enter') {
        e.preventDefault();
        handleNavigation(menuItems[focusedIndex].path);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [focusedIndex, menuItems]);
  // Function to handle navigation while preserving theme
  const handleNavigation = (path: string) => {
    if (window.innerWidth < 1024 && closeSidebar) {
      closeSidebar();
    }
    navigate(path);
  };
  const handleMenuItemClick = (index: number, path: string) => {
    setFocusedIndex(index);
    handleNavigation(path);
  };
  return <nav className="px-4 py-6" role="navigation" aria-label="Teacher Dashboard Navigation" data-id="element-11215">
      <ul className="space-y-3" data-id="element-11216">
        {menuItems.map((item, index) => {
        const Icon = item.icon;
        const isActive = currentPath === item.path || item.path === '/teacher-messages' && currentPath === '/messages';
        const isFocused = focusedIndex === index;
        return <li key={item.path} data-id="element-11217">
              <button onClick={() => handleMenuItemClick(index, item.path)} className={`flex items-center px-4 py-4 w-full text-left ${isActive || isFocused ? isDark ? 'text-white bg-[#3b82f6]/10' : 'text-gray-900 bg-[#3b82f6]/10' : isDark ? 'text-white hover:bg-navy-800/70' : 'text-gray-700 hover:bg-gray-100'} rounded-lg font-medium transition-colors`} role="menuitem" aria-current={isActive ? 'page' : undefined} tabIndex={isFocused ? 0 : -1} data-id="element-11218">
                <Icon className={`h-6 w-6 mr-3 ${isActive || isFocused ? 'text-[#3b82f6]' : ''}`} data-id="element-11219" />
                <span className="text-base" data-id="element-11220">{item.label}</span>
              </button>
            </li>;
      })}
      </ul>
    </nav>;
};